 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/title-page'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import DEDICATION from '@/components/dedication'
 import CHAPTER001 from '@/components/chapter-001'
 import CHAPTER002 from '@/components/chapter-002'
 import CHAPTER003 from '@/components/chapter-003'
 import CHAPTER004 from '@/components/chapter-004'
 import CHAPTER005 from '@/components/chapter-005'
 import CHAPTER006 from '@/components/chapter-006'
 import CHAPTER007 from '@/components/chapter-007'
 import CHAPTER008 from '@/components/chapter-008'
 import CHAPTER009 from '@/components/chapter-009'
 import CHAPTER010 from '@/components/chapter-010'
 import CHAPTER011 from '@/components/chapter-011'
 import CHAPTER012 from '@/components/chapter-012'
 import CHAPTER013 from '@/components/chapter-013'
 import CHAPTER014 from '@/components/chapter-014'
 import CHAPTER015 from '@/components/chapter-015'
 import CHAPTER016 from '@/components/chapter-016'
 import CHAPTER017 from '@/components/chapter-017'
 import CHAPTER018 from '@/components/chapter-018'
 import CHAPTER019 from '@/components/chapter-019'
 import CHAPTER020 from '@/components/chapter-020'
 import CHAPTER021 from '@/components/chapter-021'
 import THEDAYSOFPLEASURESERIES from '@/components/the-days-of-pleasure-series'
 import ANITALROSEBORO from '@/components/anita-l-roseboro'
 import MICHELLEDRAYFORD from '@/components/michelle-d-rayford'
 import SHOWMENOMERCY from '@/components/show-me-no-mercy'
 import KNIGHTOFGRANDCROSSING from '@/components/knight-of-grand-crossing'
 import NOTTHATNICE from '@/components/not-that-nice'
 import MOMENTOFTRUTH from '@/components/moment-of-truth'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/acknowledgments",
 			"name" : "acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js